import React, { useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { setSelectedItem, setSelectedSubItem } from '@/state/menuSlice';
import { CLOSE_MENU_ANIMATION_DURATION, CURSOR_TYPES, LOCALES } from "@repo/utils/constants";
import {revealAnimationContainer} from "@repo/ui";
import {setCookie} from "cookies-next";

const RevealUpContainer = revealAnimationContainer('div', 'menu-bottom-row-settings-reveal-up')

const StyledLangSelect = styled.div`
	position: relative;
	font-size: 16px;
	margin-top: 5px;
    transform: translateY(-3px);
    @media (min-width: ${({ theme }) => theme?.breakpoints?.desktop || 1024}px) and (orientation: landscape) {
        transform: unset;
    }
`;

const LanguageChange = ({ animation = true }) => {
    const dispatch = useDispatch();
    const { asPath, locale, push } = useRouter();

    const localeTo = useMemo(() => (locale === LOCALES.PL ? LOCALES.EN : LOCALES.PL), [locale]);

    const handleChangeLocale = () => {
        dispatch(setSelectedItem(false));
        dispatch(setSelectedSubItem(false));
        setTimeout(() => {
            setCookie('NEXT_LOCALE', localeTo, { maxAge: 60 * 60 * 24 * 365 });
            push(asPath, asPath, { locale: localeTo })
        }, CLOSE_MENU_ANIMATION_DURATION)
    }

    return (
        <div className='underline-animation ' data-cursor={CURSOR_TYPES.LINK} style={{position: 'relative'}}>
            {animation ? (
                <RevealUpContainer>
                    <StyledLangSelect className="language-change">
                        <div onClick={handleChangeLocale}>
                            {localeTo.toUpperCase()}
                        </div>
                    </StyledLangSelect>
                </RevealUpContainer>
            ) : (
                <StyledLangSelect className="language-change">
                    <div onClick={handleChangeLocale}>
                        {localeTo.toUpperCase()}
                    </div>
                </StyledLangSelect>
            )}
        </div>
    );
};

export default LanguageChange;
